module.exports = __webpack_public_path__ + "img/selected2-min.c776ef91.png";